<template>
  <div id="google">
    <div
      v-show="!isGoogleSigned"
      @mouseenter="ctrlDescription"
      @mouseleave="ctrlDescription"
      @ontouchchancel="ctrlDescription"
      @ontouchend="ctrlDescription"
      id="signinbuttonwrapper"
    >
      <span id="googleSignin"></span>
    </div>
    <div v-show="isShowingDescription && !isGoogleSigned" class="button">
      ログインされると、技術サンプルとして
      <br />当サイトのコンテンツに
      <br />あなたの名前が反映されます。
      <br />情報は不当な使用方法はされません。
    </div>
    <span
      id="disconnectGoogle"
      class="button"
      @click="disconnectGoogle"
      v-show="isGoogleSigned"
    >Disconnect</span>
    <div class="name" v-if="isGoogleSigned">Welcome, {{ name }}</div>
  </div>
</template>

<script>
import store from "@/store";
import constant from "@/constant/Constant";

export default {
  name: "Google",
  mounted() {
    let self = this;
    // Load GoogleAPI Script
    this.$loadScript(constant.gapi)
      .then(() => {
        self.gapi = window.gapi;
        self.initializeGoogle();
      })
      .catch(error => {
        console.log(error);
      });
  },
  methods: {
    // Initialize Google Script
    initializeGoogle() {
      this.gapi.load("auth2", () => {
        this.gapi.auth2.init(constant.gapiConditions).then(() => {
          // Always render the button.
          this.renderSignIn();
          this.GoogleAuth = this.gapi.auth2.getAuthInstance();
          if (this.GoogleAuth.isSignedIn.get()) {
            this.GoogleInfoSaveToVuex(this.GoogleAuth.currentUser.get());
          } else {
            this.GoogleInfoRemoveFromVuex();
          }
        });
      });
    },
    // Disconnect from Google
    disconnectGoogle() {
      this.GoogleAuth.disconnect();
      this.GoogleInfoRemoveFromVuex();
    },
    // On successful GoogleSignin
    handleSuccess(googleUser) {
      this.GoogleInfoSaveToVuex(googleUser);
    },
    // On failed GoogleSignin
    handleFailure() {
      console.log("Authorization did not finsh");
    },
    // Rendering GoogleSignin button
    renderSignIn() {
      this.gapi.signin2.render("googleSignin", {
        scope: "profile email openid",
        width: 77,
        height: 25,
        longtitle: false,
        onsuccess: this.handleSuccess,
        onfailure: this.handleFailure
      });
    },
    // Save GoogleInfo to Vuex
    GoogleInfoSaveToVuex(googleUser) {
      const profile = googleUser.getBasicProfile();
      store.commit("putGoogleInfo", profile);
    },
    // Remove GoogleInfo from Vuex
    GoogleInfoRemoveFromVuex() {
      store.commit("removeGoogleInfo");
    },
    ctrlDescription() {
      this.isShowingDescription = !this.isShowingDescription;
    }
  },
  data: () => ({
    GoogleAuth: null,
    gapi: null,
    isShowingDescription: false
  }),
  computed: {
    isGoogleSigned() {
      return this.GoogleAuth != null ? this.GoogleAuth.isSignedIn.get() : false;
    },
    name() {
      return store.state.GoogleInfo != null ? store.state.GoogleInfo.name : "";
    }
  }
};
</script>

<style scoped>
#google {
  padding: 5px;
}
.button {
  font-size: 50%;
  border-radius: 2px;
  padding: 6px;
  background-color: #ffffff;
  box-shadow: 1px 1px 4px gray;
}
.button:hover {
  border-radius: 2px;
  background-color: #d3d3d3;
  cursor: pointer;
  transition: all 300ms 0s ease;
  border: outset 1px rgb(181, 181, 233);
}
.name {
  margin-top: 13px;
  font-size: 70%;
}
</style>